import {Component, OnDestroy, OnInit} from '@angular/core';
import {BsModalRef, BsModalService} from 'ngx-bootstrap/modal';
import {ConfirmationModalComponent} from '../common-components/confirmation-modal/confirmation-modal.component';
import {AlertService} from '../../services/alert/alert.service';
import {LoadingService} from '../../services/loading/loading.service';
import {UserService} from '../../services/user/user.service';
import {ISubscription, Subscription} from 'rxjs-compat/Subscription';
import AppConstants, {Param} from '../common-components/AppConstants';
import {User} from '../../services/user/user';

@Component({
    selector: 'app-landingpage',
    templateUrl: './landingpage.component.html',
    styleUrls: ['./landingpage.component.css'],
    standalone: false
})
export class LandingpageComponent implements OnInit, OnDestroy {

    public modalRef: BsModalRef;
    private tmssLoader;
    currentParams: Param;
    private param_subscription: ISubscription;
    currentUser: User | any;
    private user_subscription: Subscription;
    broadCastMessages = [];

    constructor(private modalService: BsModalService,  private alertService: AlertService, private loader: LoadingService, private userService: UserService) {
        this.tmssLoader = this.loader;

        // example of how to subscribe for params also we need to unsubscribe the params check below ngOnDestroy
        this.param_subscription = this.userService.getCurrentParamObservable().subscribe(currentParams => {
            this.currentParams = currentParams as Param;
        }, (error) => {
        });
        this.user_subscription = this.userService.getUserDetails().subscribe(currentUser => {
            if (AppConstants.isNotNullCondition(currentUser)) {
                this.currentUser = currentUser;
                localStorage.setItem('currentUser', JSON.stringify(this.currentUser));
                this.userService.setUserObservable(this.currentUser);
                this.userService.getBroadcastMsgByBusinessType(this.currentUser.permissions).subscribe(res => {
                  console.log(res);
                  this.broadCastMessages = res;
                }, err => {
                  console.error('An error occurred while getting broadcast messages for :' + this.currentUser.permissions);
                })
            }
        }, (error1) => {
            this.alertService.info('unable to get current user details');
        });
    }

    ngOnInit() {
       /* this.tmssLoader.show();
        setTimeout( () => {
            this.tmssLoader.hide();
        }, 2000);*/
    }

    checkModal() {
        this.modalRef = this.modalService.show(ConfirmationModalComponent);
        this.modalRef.content.question = 'Are you sure you want to Edit/Delete/Update/Create?';
        this.modalRef.content.title = 'Your Confirmation';
        this.modalRef.content.confirmText = 'Yes';
        this.modalRef.content.cancelText = 'No';
        this.modalRef.content.emitData.subscribe(result => {
            this.alertService.info('you have selected ' + result.obj);

        });

    }

    /**
     * destroying the subscription
     */
    ngOnDestroy(): void {
        this.param_subscription.unsubscribe();
        this.user_subscription.unsubscribe();
    }
}
